// settings
const settings = {
  size: 25, // in % of with of element
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive(`rounded-corner`, {

    mounted(el: HTMLElement) {
      setRadius(el)

      // on window resize recalculate size and set it again
      window.addEventListener('resize', () => {
        setRadius(el)
      })
    },
    beforeUnmount() {
      window.removeEventListener('resize', () => {})
    },

  })
})

function setRadius(el: HTMLElement) {
  const { width, height } = el.getBoundingClientRect()
  const wsize = width * settings.size / 100
  const hsize = height * settings.size / 100

  const size = Math.min(wsize, hsize)

  el.style.setProperty('--rounded-corner-size-directive', `${size}px`)
}
